import React from "react";
const Loading = () => React.createElement("div", null, "Loading...");
export default Loading;
